<span class="toolbar-button">
    <button class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" (click)="clickGoToResources()"
      matTooltip="Resources" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
      <mat-icon> quiz</mat-icon>
    </button>
  </span>